// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drag-select[data-v-11901ffa]  .sortable-ghost {\n  opacity: 0.8;\n  color: #fff !important;\n  background: #42b983 !important;\n}\n.drag-select[data-v-11901ffa]  .el-tag {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
